import { Bearing } from './HexBearing';

/**
 * Represents a single (q, r) coordinate offset, defined relative to a
 * default forward bearing (Q, or bearing 1).
 */
export default class HexOffset {
  q: number;
  r: number;

  constructor(q: number, r: number) {
    this.q = q;
    this.r = r;
  }

  /**
   * Rotates the offset by the given bearing.
   * Offsets are defined relative to bearing 1 (Q).
   * This method calculates the new offset when facing a different direction.
   * @param {Bearing} bearing - The bearing to rotate to.
   * @returns {HexOffset} A new HexOffset instance with the rotated coordinates.
   */
  rotate(bearing: Bearing): HexOffset {
    let q = this.q;
    let r = this.r;

    // The number of 60-degree clockwise rotations to perform.
    // Bearing 1 is the default (0 rotations).
    const rotations = bearing - 1;

    for (let i = 0; i < rotations; i++) {
      const tempQ = q;
      q = -r;
      r = tempQ + r;
    }
    if (q == -0) q = 0;
    if (r == -0) r = 0;

    return new HexOffset(q, r);
  }
}
